const getters = {
  seasons: state => state.seasons,
  season: state => state.season,
}

export default getters;
